import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { loadUserAssessments, createUserAssessmentSuccess, clearCurrentUserAssessment } from 'src/app/store/assessment/assessment.actions';
import {UserAssessment,} from 'src/app/store/assessment/assessment.models';
import { User } from 'src/app/store/auth/auth.models';

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss'],
})
export class AssessmentsComponent implements OnInit, OnDestroy {
  private destroyer$: Subject<any> = new Subject();
  private startedStatus: string[] = ['CREATED', 'STARTED', 'IN_PROGRESS'];
  loadingUserAssessments$: Observable<boolean>;
  loadingUserAssessmentsError$: Observable<string>;
  userAssessments: UserAssessment[] = [];
  currentUser: User;


  constructor(private store: Store<State>, private router: Router) {
    this.store.dispatch(clearCurrentUserAssessment());
    this.store.select((state) => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe((user) => {
        this.currentUser = user;
        if (user) {
          // here we have got the authenticated user and we can now fetch all the assessment that user already did in the system
          this.store.dispatch(loadUserAssessments({ userId: user.sub }));
        }
      });
    this.store.select((state) => state.assessments.userAssessments).pipe(takeUntil(this.destroyer$)).subscribe((assessments) => this.userAssessments = assessments);
    this.loadingUserAssessments$ = this.store.select((state) => state.assessments.loadingUserAssessments);
    this.loadingUserAssessmentsError$ = this.store.select((state) => state.assessments.loadingUserAssessmentsError);
  }

  getAssessmentAction(assessment: UserAssessment): string {
    return this.startedStatus.includes(assessment.status) ? 'CONTINUE' : 'REVIEW';
  }

  ngOnInit(): void { }

  getUserFullName(): string {
    return this.currentUser
      ? `${this.currentUser.given_name} ${this.currentUser.family_name}`
      : '';
  }

  takeAssessment(): void {
    setTimeout(() => this.router.navigate(['/assessments', 'list']), 300);
  }

  continueAssessment(assessment: UserAssessment): void {
    if (this.getAssessmentAction(assessment) !== 'CONTINUE') {
      this.router.navigate(['/assessments', assessment.id, 'review']);
    } else {
      this.store.dispatch(createUserAssessmentSuccess({assessment}))
      this.router.navigate(['/assessments', assessment.id, 'testing_in_progress']);
    }
  }

  getAssessmentStatus(assessement: UserAssessment): string {
    return this.getAssessmentAction(assessement) === 'CONTINUE' ? 'IN PROGRESS' : 'COMPLETED';
  }

  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }
}
